var routes = [{
  path: '/',
  redirect: '/home'
}, {
  path: '/home',
  name: 'home',
  component: function component() {
    return import('@/views/home/index.vue');
  },
  meta: {
    pageNum: 1,
    webTitle: '首页'
  }
}, {
  path: '/about',
  name: 'about',
  component: function component() {
    return import('@/views/about/index.vue');
  },
  meta: {
    pageNum: 2,
    webTitle: '关于我们'
  }
}, {
  path: '/service',
  name: 'service',
  component: function component() {
    return import('@/views/service/index.vue');
  }
}, {
  path: '/cooperate',
  name: 'cooperate',
  component: function component() {
    return import('@/views/cooperate/index.vue');
  },
  meta: {
    pageNum: 5,
    webTitle: '合作加盟'
  }
}, {
  path: '/contactUs',
  name: 'contactUs',
  component: function component() {
    return import('@/views/contactUs/index.vue');
  },
  meta: {
    pageNum: 7,
    webTitle: '联系我们'
  }
}, {
  path: '/case_list',
  name: 'case_list',
  component: function component() {
    return import('@/views/home/CaseList.vue');
  },
  meta: {
    pageNum: 4,
    webTitle: '案例中心'
  }
}, {
  path: '/case_detail',
  name: 'case_detail',
  component: function component() {
    return import('@/views/home/CaseDetail.vue');
  },
  meta: {
    pageNum: 4,
    webTitle: '案例详情'
  }
}, {
  path: '/news_list',
  name: 'news_list',
  component: function component() {
    return import('@/views/home/NewsList.vue');
  },
  meta: {
    pageNum: 2
  }
}, {
  path: '/news_detail',
  name: 'news_detail',
  component: function component() {
    return import('@/views/home/NewsDetail.vue');
  },
  meta: {
    pageNum: 2,
    webTitle: ''
  }
}, {
  path: '/lib_detail',
  name: 'lib_detail',
  component: function component() {
    return import('@/views/service/LibDetail.vue');
  }
}, {
  path: '/auth_inquire',
  name: 'auth_inquire',
  component: function component() {
    return import('@/views/auth_inquire.vue');
  },
  meta: {
    pageNum: 3,
    webTitle: '授权查询'
  }
}, {
  path: '/renew_list',
  name: 'renew_list',
  component: function component() {
    return import('@/views/renew_list.vue');
  },
  meta: {
    pageNum: 6,
    webTitle: '最新更新'
  }
}, {
  path: '/product_manual',
  name: 'product_manual',
  component: function component() {
    return import('@/views/product_manual.vue');
  },
  meta: {
    pageNum: 6,
    webTitle: '产品操作手册'
  }
}, {
  path: '/hardware_device',
  name: 'hardware_device',
  component: function component() {
    return import('@/views/device/hardware_device.vue');
  },
  meta: {
    pageNum: 99,
    type: 'product',
    webTitle: '硬件设备'
  }
}, {
  path: '/device_list',
  name: 'device_list',
  component: function component() {
    return import('@/views/device/device_list.vue');
  },
  meta: {
    pageNum: 99,
    type: 'product',
    webTitle: '硬件列表'
  }
}, {
  path: '/product_detail',
  name: 'product_detail',
  component: function component() {
    return import('@/views/device/product_detail.vue');
  },
  meta: {
    pageNum: 99,
    type: 'product',
    webTitle: '硬件详情'
  }
}, {
  path: '/charging_pile',
  name: 'charging_pile',
  component: function component() {
    return import('@/views/series_product/charging_pile/index.vue');
  },
  meta: {
    pageNum: 99,
    type: 'product',
    webTitle: '充电桩'
  }
}, {
  path: '/chauffeur',
  name: 'chauffeur',
  component: function component() {
    return import('@/views/series_product/chauffeur/index.vue');
  },
  meta: {
    type: 'product',
    webTitle: '城际约车'
  }
}, {
  path: '/multifunctional_mall',
  name: 'multifunctional_mall',
  component: function component() {
    return import('@/views/series_product/multifunctional_mall/index.vue');
  },
  meta: {
    type: 'product',
    webTitle: '多功能商城'
  }
}, {
  path: '/wn_repast',
  name: 'wn_repast',
  component: function component() {
    return import('@/views/series_product/wn_repast/index.vue');
  },
  meta: {
    type: 'product',
    webTitle: '悟能餐饮'
  }
}, {
  path: '/parking',
  name: 'parking',
  component: function component() {
    return import('@/views/series_product/parking/index.vue');
  },
  meta: {
    type: 'product',
    webTitle: '无感停车'
  }
}, {
  path: '/community_group',
  name: 'community_group',
  component: function component() {
    return import('@/views/series_product/community_group/index.vue');
  },
  meta: {
    type: 'product',
    webTitle: '社区拼团'
  }
}, {
  path: '/404',
  // name: 'community_group',
  component: function component() {
    return import('@/views/error_page/404.vue');
  },
  meta: {
    type: 'product' // webTitle:'社区拼团'

  }
}, {
  path: '*',
  redirect: '/404'
}];
export default routes;